//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_epsilon3 = 0.001;\n\
";
